import { laravelGraphqlEndpoint } from '@/globals/globals'
import { Box, Flex, Text } from '@chakra-ui/react'
import { gql, GraphQLClient } from 'graphql-request'
import React from 'react'
import { useDropzone } from 'react-dropzone'
import { v4 as uuidv4 } from 'uuid'
import { ImageIcon } from './icons/ImageIcon'

type Props = {
  images: any
  setImages: Function
}

async function uploadFile(file: any) {
  const graphQLClient = new GraphQLClient(laravelGraphqlEndpoint)
  let mutation = gql`
    mutation Upload($file: Upload!) {
      upload(file: $file)
    }
  `
  let variables = {
    file: file,
  }
  return await graphQLClient.request(mutation, variables)
}

export const ImageDropzone = ({ images, setImages }: Props) => {
  const [uploading, setUploading] = React.useState(false)

  async function handleDrop(data: any) {
    setUploading(true)
    let dataArray: any[] = []
    for (const file of data) {
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      })
      await uploadFile(file).then(data => {
        dataArray.push({
          preview: URL.createObjectURL(file),
          path: `${data['upload']}`,
          uuid: uuidv4(),
        })
      })
    }
    setImages([...(images || []), ...(dataArray || [])])
    setUploading(false)
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/*',
    onDrop: acceptedFiles => {
      handleDrop(acceptedFiles)
    },
  })

  if (uploading)
    return (
      <Flex
        height='143px'
        alignItems='center'
        bg='gray.100'
        rounded='lg'
        borderColor='gray.900'
        borderWidth={1}
        justifyContent='center'
        p={8}
        textAlign='center'
        mb='6'
        borderRadius={8}
        cursor='pointer'
        {...getRootProps()}>
        <Text>Uploading...</Text>
      </Flex>
    )

  return (
    <Flex
      alignItems='center'
      bg='gray.100'
      rounded='lg'
      borderColor='gray.900'
      borderWidth={1}
      justifyContent='center'
      p={8}
      textAlign='center'
      mb='6'
      borderRadius={8}
      cursor='pointer'
      {...getRootProps()}>
      <input {...getInputProps()} />
      <Box>
        <Box sx={{ transform: `scale(${isDragActive ? '1.1' : '1'})` }}>
          <ImageIcon
            _groupHover={{ fill: 'black' }}
            fill='gray.500'
            mt={-8}
            mb={2}
            width={20}
            height={20}
          />
        </Box>
        <Text fontSize='sm'>
          {isDragActive
            ? 'Drop the files here ...'
            : 'Drag some image files here, or click to select files'}
        </Text>
      </Box>
    </Flex>
  )
}
